import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertTriangle, CreditCard, LogOut } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

const SubscriptionRequired: React.FC = () => {
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    window.location.href = "/login";
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mb-4">
            <AlertTriangle className="w-6 h-6 text-amber-600" />
          </div>
          <CardTitle className="text-xl">Subscription Required</CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          <p className="text-gray-600">
            Your account requires an active subscription to access the platform. 
            Please complete the subscription process to continue.
          </p>
          
          <div className="space-y-3">
            <Link to="/billing" className="block">
              <Button className="w-full" size="lg">
                <CreditCard className="w-4 h-4 mr-2" />
                Go to Billing
              </Button>
            </Link>
            
            <Button 
              variant="outline" 
              className="w-full" 
              onClick={handleLogout}
            >
              <LogOut className="w-4 h-4 mr-2" />
              Logout
            </Button>
            
            <p className="text-sm text-gray-500">
              Need help? Contact support at{" "}
              <a 
                href="mailto:support@hirelo.io" 
                className="text-blue-600 hover:text-blue-800"
              >
                support@hirelo.io
              </a>
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SubscriptionRequired; 